var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }